import type { Question } from '@dmp/qqms/types';
import type { CardState } from '../state/state-types';

export type VisualCardType =
    | Question['formType']
    | 'titleCard'
    | 'thankYouCard'
    | 'pollResultCard'
    | 'dynamicCoreQuestion';

export const getVisualCardType = ({
    type,
    formType,
}: {
    type: CardState['type'];
    formType: Question['formType'];
}): VisualCardType => {
    switch (type) {
        case 'forkedQuestion':
        case 'linearQuestion':
            return formType;

        // includes: 'thankYouCard' and 'dynamicCoreQuestion'
        default:
            return type;
    }
};
